package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SettingsW500Rounded: ImageVector
    get() {
        if (_settingsW500Rounded != null) {
            return _settingsW500Rounded!!
        }
        _settingsW500Rounded = Builder(name = "SettingsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(428.46f, 888.13f)
                quadToRelative(-28.2f, 0.0f, -48.54f, -18.6f)
                quadToRelative(-20.33f, -18.6f, -24.33f, -45.79f)
                lineToRelative(-9.0f, -66.24f)
                quadToRelative(-11.09f, -4.28f, -21.04f, -10.33f)
                quadToRelative(-9.94f, -6.04f, -19.51f, -12.84f)
                lineToRelative(-61.76f, 26.0f)
                quadToRelative(-25.95f, 11.24f, -52.15f, 2.12f)
                quadToRelative(-26.2f, -9.12f, -40.67f, -33.32f)
                lineToRelative(-51.55f, -90.37f)
                quadToRelative(-14.48f, -23.96f, -8.36f, -51.03f)
                quadToRelative(6.12f, -27.08f, 28.08f, -44.56f)
                lineToRelative(52.76f, -40.0f)
                quadToRelative(-0.76f, -6.04f, -0.76f, -11.58f)
                verticalLineToRelative(-23.18f)
                quadToRelative(0.0f, -5.54f, 0.76f, -11.58f)
                lineToRelative(-52.76f, -39.76f)
                quadToRelative(-22.2f, -17.48f, -28.2f, -44.56f)
                quadToRelative(-6.0f, -27.08f, 8.48f, -51.27f)
                lineToRelative(51.55f, -90.13f)
                quadToRelative(14.47f, -23.96f, 40.55f, -33.2f)
                quadToRelative(26.08f, -9.24f, 52.03f, 2.0f)
                lineToRelative(62.48f, 26.0f)
                quadToRelative(9.57f, -6.8f, 19.65f, -12.73f)
                quadToRelative(10.09f, -5.92f, 20.42f, -10.2f)
                lineToRelative(9.0f, -66.48f)
                quadToRelative(4.0f, -27.43f, 24.33f, -46.03f)
                quadToRelative(20.34f, -18.6f, 48.54f, -18.6f)
                horizontalLineToRelative(103.08f)
                quadToRelative(28.2f, 0.0f, 48.54f, 18.6f)
                quadToRelative(20.33f, 18.6f, 24.33f, 46.03f)
                lineToRelative(9.0f, 66.48f)
                quadToRelative(11.09f, 4.28f, 21.04f, 10.2f)
                quadToRelative(9.94f, 5.93f, 19.51f, 12.73f)
                lineToRelative(61.76f, -26.0f)
                quadToRelative(25.95f, -11.24f, 52.15f, -2.0f)
                reflectiveQuadToRelative(40.67f, 33.2f)
                lineToRelative(51.55f, 90.13f)
                quadToRelative(14.48f, 24.19f, 8.48f, 51.27f)
                quadToRelative(-6.0f, 27.08f, -28.2f, 44.56f)
                lineToRelative(-53.0f, 39.76f)
                quadToRelative(0.76f, 6.04f, 0.76f, 11.58f)
                lineTo(788.13f, 480.0f)
                quadToRelative(0.0f, 6.04f, -0.12f, 11.59f)
                quadToRelative(-0.12f, 5.54f, -1.64f, 11.58f)
                lineToRelative(53.0f, 39.76f)
                quadToRelative(22.2f, 17.48f, 28.2f, 44.56f)
                quadToRelative(6.0f, 27.08f, -8.48f, 51.27f)
                lineToRelative(-52.55f, 90.37f)
                quadToRelative(-14.47f, 23.96f, -40.55f, 33.2f)
                quadToRelative(-26.08f, 9.24f, -52.03f, -2.0f)
                lineToRelative(-60.48f, -26.0f)
                quadToRelative(-9.57f, 6.8f, -19.65f, 12.84f)
                quadToRelative(-10.09f, 6.05f, -20.42f, 10.33f)
                lineToRelative(-9.0f, 66.24f)
                quadToRelative(-4.0f, 27.19f, -24.33f, 45.79f)
                quadToRelative(-20.34f, 18.6f, -48.54f, 18.6f)
                lineTo(428.46f, 888.13f)
                close()
                moveTo(442.63f, 797.13f)
                horizontalLineToRelative(73.5f)
                lineToRelative(14.24f, -105.52f)
                quadToRelative(31.24f, -8.0f, 58.34f, -23.62f)
                quadToRelative(27.09f, -15.62f, 49.09f, -38.58f)
                lineToRelative(98.77f, 41.0f)
                lineToRelative(36.13f, -63.69f)
                lineToRelative(-85.29f, -64.52f)
                quadToRelative(5.0f, -14.48f, 7.24f, -30.22f)
                quadToRelative(2.24f, -15.74f, 2.24f, -31.98f)
                quadToRelative(0.0f, -16.24f, -2.24f, -31.98f)
                quadToRelative(-2.24f, -15.74f, -7.24f, -30.22f)
                lineToRelative(85.76f, -64.52f)
                lineToRelative(-36.6f, -63.69f)
                lineToRelative(-98.53f, 42.0f)
                quadToRelative(-22.0f, -23.72f, -49.09f, -39.58f)
                quadToRelative(-27.1f, -15.86f, -58.58f, -23.62f)
                lineToRelative(-13.0f, -105.52f)
                horizontalLineToRelative(-73.98f)
                lineToRelative(-13.52f, 105.28f)
                quadToRelative(-31.72f, 7.76f, -58.94f, 23.62f)
                quadToRelative(-27.21f, 15.86f, -49.45f, 38.82f)
                lineToRelative(-98.28f, -41.0f)
                lineToRelative(-36.37f, 63.69f)
                lineToRelative(85.04f, 63.29f)
                quadToRelative(-5.0f, 15.47f, -7.24f, 30.83f)
                quadToRelative(-2.24f, 15.36f, -2.24f, 32.6f)
                quadToRelative(0.0f, 16.24f, 2.24f, 31.72f)
                reflectiveQuadToRelative(7.24f, 30.95f)
                lineToRelative(-85.04f, 64.05f)
                lineToRelative(36.37f, 63.69f)
                lineToRelative(98.28f, -41.76f)
                quadToRelative(22.24f, 23.48f, 49.57f, 39.34f)
                quadToRelative(27.34f, 15.86f, 58.82f, 23.86f)
                lineToRelative(12.76f, 105.28f)
                close()
                moveTo(481.28f, 620.0f)
                quadToRelative(58.0f, 0.0f, 99.0f, -41.0f)
                reflectiveQuadToRelative(41.0f, -99.0f)
                quadToRelative(0.0f, -58.0f, -41.0f, -99.0f)
                reflectiveQuadToRelative(-99.0f, -41.0f)
                quadToRelative(-58.76f, 0.0f, -99.38f, 41.0f)
                reflectiveQuadToRelative(-40.62f, 99.0f)
                quadToRelative(0.0f, 58.0f, 40.62f, 99.0f)
                reflectiveQuadToRelative(99.38f, 41.0f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _settingsW500Rounded!!
    }

private var _settingsW500Rounded: ImageVector? = null
